import InfoIcon from '@mui/icons-material/Info';
import { FormHelperText, IconButton, Stack, Tooltip } from "@mui/material";

interface LabelWithHintProps {
    label: string;
    hint?: string;
    required?: boolean;
}

const LabelWithHint: React.FC<LabelWithHintProps> = (
    { label, hint, required = false }) => {
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <FormHelperText sx={{ fontSize: '0.75rem' }}>
                    {label}
                    {required && <span style={{ color: '#d32f2f', marginLeft: '2px' }}>*</span>}
                </FormHelperText>
                {hint && (
                    <Tooltip title={hint} arrow placement="right">
                        <IconButton size="small" sx={{ padding: 0 }}>
                            <InfoIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>
        );
    };

export default LabelWithHint;